import type { SVGProps } from 'react';
const SvgBorderAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#border_all_svg__a)">
      <path
        fill="currentColor"
        d="M3 3v18h18V3H3Zm8 16H5v-6h6v6Zm0-8H5V5h6v6Zm8 8h-6v-6h6v6Zm0-8h-6V5h6v6Z"
      />
    </g>
    <defs>
      <clipPath id="border_all_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBorderAll;
